var header = document.getElementById("HeaderWrapper");
var sticky = header.offsetTop;

bodyy = document.querySelector("body");

window.onscroll = function () {
    if (window.scrollY > 170) {
        header.classList.add("Sifat__stuck");
        bodyy.classList.add("Sifat__stuck");
    } else {
        header.classList.remove("Sifat__stuck");
        bodyy.classList.remove("Sifat__stuck");
    }
};